import { color, units } from '@m/alchemy-ui/theme';
import styled from 'styled-components';

export const CommunityPageText = styled.div`
  width: auto;
  max-width: 100%;
`;

export const TextButton = styled.div`
  margin-top: 20px;
`;

export const TextHtmlButton = styled.a<{ bgColor: string }>`
  display: inline-block;
  position: relative;
  min-width: 40px;
  padding: 8px 16px;
  background-color: ${({ bgColor }) => `#${bgColor}`};
  background-image: linear-gradient(90deg, ${({ bgColor }) => `#${bgColor}`}, rgba(255, 255, 255, 0.18));
  border: 0 solid transparent;
  border-radius: 18px;
  cursor: pointer;
  text-align: center;
  font:
    700 14px 'Nunito',
    -apple-system,
    BlinkMacSystemFont,
    Helvetica,
    Arial,
    sans-serif;
  color: #fff;
  line-height: 1.43;
  transition: background 0.3s ease-in-out;
  word-break: keep-all;

  &:hover {
    background-image: linear-gradient(90deg, ${({ bgColor }) => `#${bgColor}`}, rgba(0, 0, 0, 0));
    text-decoration: none;
  }
`;

export const TextEditorOutputField = styled.div`
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    line-height: 1.0625;
  }

  h1 {
    font-weight: 400;
    font-size: 32px;
    line-height: 1.0625;
  }

  h2 {
    font-weight: 600;
    font-size: 24px;
  }

  b {
    font-weight: 700;
  }

  a {
    color: ${color('typeLink')} !important;
    text-decoration: underline;
  }

  em {
    font-style: italic;
  }

  li {
    line-height: ${units(3)};
  }

  ul {
    list-style: disc;
    margin-left: ${units(2.5)};
    margin-bottom: ${units(2.5)};
    margin-top: ${units(2.5)};
    padding-left: ${units(2)};
  }

  ol {
    list-style: decimal;
    padding-left: ${units(2)};
    margin-left: ${units(2.5)};
    margin-bottom: ${units(2.5)};
    margin-top: ${units(2.5)};
  }

  p {
    margin-top: ${units(2.5)};
    margin-bottom: 0px;
  }

  p:first-child {
    margin-top: 0px;
  }
`;
